<template>
  <el-dialog
    title="修改手机号"
    :visible.sync="dialogInfo.flag"
    v-if="dialogInfo.flag"
    width="550px"
    :close-on-click-modal="false"
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="ruleForm"
      ref="ruleForm"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="新手机号码：" prop="newPhone">
            <el-input
              placeholder="请输入新手机号码"
              v-model="ruleForm.newPhone"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="sureSubmit" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { validMobile } from "@/utils/rules/validMobile.js";
import { updateMobile } from "@/api/user";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ruleForm: {
        newPhone: "",
      },
      rules: {
        newPhone: [
          {
            required: true,
            validator: validMobile,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    closeDia() {
      this.$emit("closeDialog", false);
    },
    sureSubmit() {
      if (!this.ruleForm.newPhone) {
        this.$message({
          type: "warning",
          message: "请输入新手机号码",
        });
      } else {
        let params = {
          userId: this.dialogInfo.userId,
          phone: this.dialogInfo.phone,
          newPhone: this.ruleForm.newPhone
        };
        updateMobile(params).then((res) => {
          if (!res || res.code != 0) return;
          this.$emit("closeDialog", true, this.ruleForm.newPhone);
          this.$message({
            message: res.msg,
            type: "success",
          });
        });
      }
    },
  },
};
</script>

<style>
</style>
